module.exports = __webpack_public_path__ + "img/bmi-full-white.aab23795.svg";